import $http from '@/api/index';
import store from '@/store';
import { toArray } from '@/utils';
import isUndefined from 'lodash/isUndefined';

/**
 * @typedef {{}} SiteCard
 * @property {Number} id
 * @property {String} idAlias
 * @property {String} name
 * @property {DomainCard[]} domains
 */

/**
 * @typedef {{}} DomainCard
 * @property {Number} id
 * @property {String} idAlias
 * @property {String} name
 * @property {String} url
 */

/**
 * @typedef {{}} ListItemImage
 * @property {String} src
 * @property {String} alt
 */

/**
 * @typedef {{}} ListItemFlag
 * @property {String} color
 * @property {String} tooltip
 */

/**
 * @typedef {{}} ListItemChip
 * @property {String}             value
 * @property {String|null}        color
 * @property {String|null}        textColor
 * @property {ListItemImage|null} image
 * @property {string|null}        icon
 * @property {string|null}        tooltip
 * @property {string|null}        url
 * @property {String[]|null}      action
 * @property {Boolean}            humanDate
 * @property {Boolean}            date
 * @property {String[]|null}      translationVariables
 */

/**
 * @typedef {{}} ListItem
 * @property {Number}             id
 * @property {String}             type
 * @property {String}             title
 * @property {String|null}        subtitle
 * @property {ListItemImage|null} image
 * @property {ListItemFlag|null}  flag
 * @property {String|null}        url
 * @property {Boolean}            hasChildren
 * @property {ListItemChip[]}     chips
 * @property {String[]}           metadata
 * @property {String[]}           actions
 * @property {String[]}           params
 * @property {Boolean}            keepImageAspectRatio
 */

/**
 * @typedef {{}} TaxonomyCard
 * @property {Number}       int
 * @property {String}       type
 * @property {String}       name
 * @property {Number}       parentId
 * @property {Array}        ancestors
 * @property {Boolean}      hasChildren
 * @property {SiteCard}     creatorSite
 * @property {StaffCard}    creatorStaff
 * @property {String}       creationDate
 * @property {String}       modificationDate
 * @property {StaffCard}    lastModificationStaff
 * @property {DomainCard}   domain
 * @property {DomainCard[]} crossDomains
 * @property {ListItem}     list
 */

export default {
  /**
   * Fetches a taxonomy information.
   * @param id
   * @return {Promise<TaxonomyCard>}
   */
  async fetch(id) {
    return $http.get(`/api/taxon/${id}`);
  },

  /**
   * Creates a new taxonomy with the given payload.
   * @param payload
   * @param type
   * @return {Promise<TaxonomyCard>}
   */
  async create(payload, type = 'section') {
    const config = store.getters.getEntityConfig(type);
    const apiPath = config.apiPath ? config.apiPath : `/api/category/${type}`;
    if (isUndefined(payload.parentId)) {
      payload.parentId = null;
    }
    payload.context = store.getters.context;
    return $http.post(apiPath, payload);
  },

  async search(filters, source = {}) {
    if (filters.sort) {
      filters.sort = toArray(filters.sort)
        .map(sort => ({
          field: Object.keys(sort)
            .pop(),
          criteria: Object.values(sort)
            .pop(),
        }));
    }

    if (!filters.siteId) {
      filters.siteId = store.getters.siteId;
    }
    return $http.post('/api/category/search', filters, { cancelToken: source.token })
      .catch((e) => {
        console.warn('Search exception:', e);
        return {
          canceled: true,
          results: [],
        };
      });
  },

};
